import React from 'react';
import {useSelector} from "react-redux";

import {isEducator} from "utils/role";

export default function () {
    const me = useSelector(state => state.me);
    if (isEducator(me)) {
        let curriculum = 'Other';
        if (me.school && me.school.curriculum) {
            curriculum = me.school.curriculum.name;
        } else if (me.curriculum) {
            curriculum = me.curriculum.name;
        }

        return (
            <div className="flex-row user-info-field">
                <div className="user-info-field-label">Curriculum</div>
                <div>{curriculum}</div>
            </div>
        );
    }

    return null;
};
